module.exports = __webpack_public_path__ + "static/media/editFloor.06c3cb5b.svg";